import { rangeMapper, clampNumber } from '../helpers';

let playingHeader = false;

/**
 * Transform header to match the scroll position
 *
 * @param  {HTMLElement} header
 * @param  {HTMLImageElement} logo
 */
function scrollheader(header:HTMLElement,
  logo:HTMLImageElement,
  mobileNav:HTMLElement,
  initial:boolean = false) {
  // Set max translation value
  const maxTranslate:number = 40 + header.getBoundingClientRect().height;

  // If scrolled past header height
  // And is not initial page render
  // if (window.scrollY > (maxTranslate + 2000) && !initial) { return; }

  const transform = {
    transY: clampNumber(rangeMapper(window.scrollY, 0, maxTranslate, 0, 40), 0, 40),
    // scale: clampNumber(rangeMapper(window.scrollY, 0, maxTranslate, 1, 0.8), 0.8, 1),
    // logoTransY: clampNumber(rangeMapper(window.scrollY, 0, maxTranslate, 20, 0), 0, 20),
    // mobileTransY: clampNumber(rangeMapper(window.scrollY, 0, maxTranslate, 47, 0), 0, 47),
  };

  header.style.transform = `translateY(-${transform.transY}px)`;  // eslint-disable-line
  // eslint-disable-next-line max-len
  // logo.style.transform = `scale(${transform.scale.toFixed(2)}) translateY(-${transform.logoTransY}%)`;  // eslint-disable-line
  // mobileNav.style.transform = `translateY(-${transform.mobileTransY}px)`;  // eslint-disable-line

  playingHeader = false;
}

export default function initHeaderScroll() {
  // @ts-ignore
  const header:HTMLElement = document.querySelector('header.header')!;
  // @ts-ignore
  const logo:HTMLImageElement = document.querySelector('header.header .header__logo')!;
  // @ts-ignore
  const mobileNav:HTMLElement = document.querySelector('.header__nav--mobile nav')!;

  if (header) {
    scrollheader(header, logo, mobileNav, true);

    window.addEventListener('scroll', () => {
      if (!playingHeader) {
        requestAnimationFrame(() => {
          playingHeader = true;
          scrollheader(header, logo, mobileNav);
        });
      }
    }, { passive: true });
  }
}
